// icons
import { MdCalendarMonth } from "react-icons/md";

const agenda = {
  id: 'agenda-group',
  type: 'group',
  roles: [1, 100, 110],
  breadcrumbs: false,
  children: [
    {
      id: 'agenda',
      title: 'Agenda',
      type: 'item',
      breadcrumbs: false,
      icon: MdCalendarMonth,
      url: '/agenda'
    }
  ]
};

export default agenda;
